var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutResDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 480,
    viewBox: "0 0 489 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.541 409.445C417.927 422.448 415.282 424.321 406.64 430.091C322.362 486.364 200.416 472.762 170.63 467.219C122.575 458.275 98.9749 455.117 64.1219 423.629C-15.0746 352.078 -11.2226 202.818 49.2931 110.357C56.4684 99.3942 115.837 14.3304 212.384 1.70961C214.746 1.40087 326.596 -13.3689 402.064 49.8582C412.867 58.9088 430.252 75.2339 446.374 100.132C505.321 191.172 505.508 332.172 430.541 409.445Z",
    fill: "#F0E3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.978 371.14L198.334 457.632H310.222L295.648 371.14H207.978Z",
    fill: "#8A49D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 160.024V375.877C0 393.634 14.1501 408.155 31.901 408.613C110.741 410.645 386.486 415.575 461.537 414.469C474.436 414.279 484.885 403.956 485.258 391.061C486.705 340.915 489.055 220.332 480.357 164.35C478.526 152.56 468.575 143.745 456.65 143.363C390.592 141.25 98.2839 134.54 23.2684 136.225C10.3308 136.515 0 147.083 0 160.024Z",
    fill: "#8A49D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.543 158.973V364.048C13.543 374.416 21.8653 382.863 32.2314 383.018L450.738 388.189C461.016 388.342 469.44 380.074 469.479 369.795L470.179 166.552C470.206 159.203 464.351 153.181 457.004 153.002L28.5301 144.346C20.3125 144.146 13.543 150.753 13.543 158.973Z",
    fill: "url(#paint0_linear_4_50729)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M472.631 396.559C472.627 396.559 472.624 396.559 472.621 396.559L13.5349 388.737C13.2333 388.732 12.993 388.484 12.9981 388.182C13.0031 387.88 13.2395 387.659 13.5536 387.645L472.64 395.467C472.941 395.472 473.182 395.721 473.176 396.022C473.171 396.321 472.928 396.559 472.631 396.559Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.543 158.973V364.048C13.543 374.416 21.8653 382.863 32.2314 383.018L450.738 388.189C461.016 388.342 469.44 380.074 469.479 369.795L470.179 166.552C470.206 159.203 464.351 153.181 457.004 153.002L28.5301 144.346C20.3125 144.146 13.543 150.753 13.543 158.973Z",
    fill: "#E8BB2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M247.616 406.113C244.681 406.113 242.293 403.725 242.293 400.79C242.293 397.854 244.681 395.467 247.616 395.467C250.551 395.467 252.939 397.854 252.939 400.79C252.938 403.725 250.551 406.113 247.616 406.113ZM247.616 396.559C245.283 396.559 243.385 398.457 243.385 400.79C243.385 403.123 245.283 405.02 247.616 405.02C249.948 405.02 251.846 403.123 251.846 400.79C251.846 398.457 249.948 396.559 247.616 396.559Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 475.328H170.567C166.118 475.328 162.777 472.161 163.638 468.759L165.739 460.449C166.371 457.95 169.12 456.115 172.386 456.014L330.251 451.088C333.663 450.981 336.684 452.792 337.427 455.389L341.215 468.625C342.199 472.064 338.843 475.328 334.322 475.328Z",
    fill: "#8A49D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.72 458.277C258.422 458.277 258.178 458.038 258.174 457.739C258.17 457.437 258.41 457.189 258.712 457.185L265.477 457.086C265.77 457.078 266.026 457.323 266.031 457.624C266.035 457.926 265.794 458.174 265.493 458.178L258.728 458.277C258.725 458.277 258.722 458.277 258.72 458.277Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M169.697 470.759C169.669 470.759 169.639 470.757 169.61 470.752C169.312 470.705 169.11 470.425 169.157 470.127L170.122 464.083C170.642 460.829 173.41 458.432 176.705 458.384L248.456 457.335C248.764 457.356 249.005 457.571 249.01 457.873C249.014 458.175 248.773 458.423 248.472 458.427L176.721 459.476C173.958 459.517 171.637 461.526 171.201 464.255L170.236 470.299C170.193 470.568 169.961 470.759 169.697 470.759Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M419.67 383.048L58.3334 378.884C47.8245 378.763 39.3672 369.956 39.3672 359.134V225.68C39.3672 214.649 48.143 205.756 58.855 205.933L420.192 211.889C430.664 212.061 439.065 220.852 439.065 231.636V363.298C439.066 374.293 430.347 383.171 419.67 383.048Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M430.163 202.431L48.6218 198.76C43.8159 198.714 39.9531 195.848 39.9531 192.328V179.204C39.9531 175.612 43.9697 172.717 48.8739 172.773L430.415 177.121C435.213 177.175 439.063 180.039 439.063 183.552V195.999C439.063 199.585 435.059 202.478 430.163 202.431Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M291.537 364.998L74.6905 361.975C65.719 361.85 58.5011 354.561 58.4632 345.589L58.0119 238.361C57.9735 229.245 65.3526 221.835 74.4685 221.835H291.766C300.855 221.835 308.223 229.203 308.223 238.292V348.543C308.223 357.722 300.715 365.126 291.537 364.998Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M419.337 289.986H330.205C325.222 289.986 321.182 285.946 321.182 280.962V231.059C321.182 225.998 325.343 221.926 330.403 222.038L419.536 223.997C424.441 224.104 428.361 228.112 428.361 233.018V280.962C428.361 285.946 424.321 289.986 419.337 289.986Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M419.721 363.984H329.822C325.05 363.984 321.182 360.116 321.182 355.344V304.474C321.182 299.702 325.05 295.834 329.822 295.834H419.721C424.492 295.834 428.361 299.702 428.361 304.474V355.344C428.361 360.116 424.492 363.984 419.721 363.984Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6621 465.969C26.6621 465.969 24.5838 469.245 24.0611 478.417C24.0124 479.272 24.6893 480 25.5453 480H41.7998C42.4538 480 42.9206 479.358 42.7111 478.739C41.7587 475.92 38.8787 469.047 32.4527 465.119L26.6621 465.969Z",
    fill: "url(#paint1_linear_4_50729)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9551 459.754L26.8744 467.463C26.9538 468.128 27.475 468.66 28.1404 468.737C29.0295 468.839 30.3217 468.911 31.5774 468.704C32.719 468.516 33.5405 467.499 33.5405 466.342V458.9L25.9551 459.754Z",
    fill: "url(#paint2_linear_4_50729)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8777 465.119C66.8777 465.119 63.7666 469.955 63.8331 476.593C63.8487 478.156 65.1577 479.402 66.7213 479.402H91.9663C93.1483 479.402 93.6283 477.883 92.6609 477.203C87.8839 473.849 78.4945 467.582 71.7036 465.119H66.8777Z",
    fill: "url(#paint3_linear_4_50729)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2773 456.794L66.2383 466.315C66.4578 467.379 67.4993 468.096 68.5605 467.859C69.2056 467.715 69.9667 467.439 70.7798 466.93C71.5526 466.447 71.9443 465.528 71.7864 464.63L69.7581 453.096L64.2773 456.794Z",
    fill: "url(#paint4_linear_4_50729)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5572 324.424C29.5572 324.424 22.7388 330.435 21.4558 337.668C20.1725 344.9 25.0913 462.447 25.0913 462.447C25.0913 462.447 31.9093 463.582 35.424 461.452C35.424 461.452 39.5926 385.165 42.7611 367.536C42.7611 367.536 59.3782 446.56 63.9824 460.839C63.9824 460.839 70.5509 461.638 72.6693 460.388C72.6693 460.388 68.3163 357.951 62.8469 339.739L29.5572 324.424Z",
    fill: "#A466BE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5624 365.057C42.2336 365.057 41.9334 364.836 41.847 364.503L39.0241 353.673L33.0105 349.816C32.6667 349.595 32.5664 349.137 32.7872 348.793C33.008 348.449 33.4646 348.349 33.8099 348.57L40.0671 352.584C40.2236 352.684 40.3371 352.84 40.3835 353.02L43.2793 364.13C43.3828 364.526 43.1456 364.93 42.7499 365.033C42.687 365.049 42.6246 365.057 42.5624 365.057Z",
    fill: "url(#paint5_linear_4_50729)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8413 256.503C68.1384 254.12 60.6367 260.06 60.6367 260.06L74.4302 281.836C74.4302 281.836 102.634 281.279 122.842 265.703C119.06 261.63 116.434 257.128 114.749 253.623C109.538 255.789 103.537 257.059 96.8413 256.503Z",
    fill: "url(#paint6_linear_4_50729)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.791 214.371C141.752 213.452 140.506 213.201 140.115 214.035L136.452 221.851C135.745 223.361 135.518 225.051 135.802 226.695L137.087 231.243C137.472 233.462 136.892 235.735 135.486 237.493C132.121 241.7 124.953 249.384 114.75 253.623C116.435 257.128 119.061 261.63 122.844 265.703C130.258 259.988 136.599 252.253 140.073 241.779C141.737 241.268 142.849 239.701 142.783 237.961L141.791 214.371Z",
    fill: "url(#paint7_linear_4_50729)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.291 269.128C96.1864 258.24 76.9397 253.321 65.7963 251.3C60.9144 250.415 56.102 253.132 54.3723 257.782C49.3577 271.262 35.719 306.333 33.0756 312.36C30.9068 317.305 28.6422 322.135 27.2033 325.154C26.3436 326.958 27.0947 329.117 28.8949 329.984C38.2702 334.503 55.1402 339.616 61.9793 341.611C63.4838 342.049 64.9817 340.92 64.9817 339.353C64.9817 338.024 65.3429 336.72 66.0267 335.58L91.9288 292.417C108.073 310.317 122.211 311.954 133.072 308.036C131.246 302.392 130.051 296.738 129.478 291.073C113.433 288.324 106.291 269.128 106.291 269.128Z",
    fill: "url(#paint8_linear_4_50729)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.997 288.069L153.101 284.208C143.727 290.646 135.891 292.172 129.477 291.073C130.05 296.738 131.245 302.392 133.071 308.036C147.379 302.875 155.997 288.069 155.997 288.069Z",
    fill: "url(#paint9_linear_4_50729)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.954 288.139L170.268 288.775L185.288 280.386C183.131 279.034 170.94 281.797 170.94 281.797C170.94 281.797 158.194 279.869 154.745 279.864C151.88 279.861 152.289 283.981 152.51 285.377C152.555 285.662 152.592 285.833 152.592 285.833L153.954 288.139Z",
    fill: "url(#paint10_linear_4_50729)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1229 231.304L72.5156 252.308C72.5156 252.308 82.4054 259.153 90.362 258.501L94.6577 239.615L81.1229 231.304Z",
    fill: "url(#paint11_linear_4_50729)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6638 216.985C95.861 217.265 101.891 239.048 101.891 239.048L89.3799 242.226L80.5977 222.43C80.5977 222.43 92.3635 212.31 95.6638 216.985Z",
    fill: "url(#paint12_linear_4_50729)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3075 225.437L89.1146 236.221C89.1634 236.359 89.2287 236.487 89.3132 236.607C89.8299 237.341 91.7925 239.736 94.1206 237.578C96.233 235.621 98.19 233.866 99.9974 233.547C100.809 233.404 101.595 233.899 101.815 234.693C102.362 236.673 103.513 241.156 103.918 245.203C104.001 246.024 103.434 246.766 102.623 246.921C100.179 247.385 94.9982 248.219 90.6729 247.914C90.0867 247.873 89.5711 247.521 89.3266 246.987C88.1347 244.382 84.4826 236.48 83.1242 234.435C81.8492 232.516 78.7238 232.57 77.413 232.686C76.9834 232.724 76.5608 232.585 76.2363 232.301C75.0896 231.296 72.9072 228.73 75.9771 225.658C76.6196 225.015 76.6023 223.977 75.9401 223.355C74.6218 222.115 73.2118 219.917 75.4083 217.19C77.6408 214.419 80.588 214.86 82.3935 215.519C83.1238 215.785 83.9201 215.477 84.317 214.808C84.5429 214.428 84.937 214.14 85.6203 214.199C86.5412 214.278 87.3156 213.51 87.299 212.586C87.2671 210.81 87.9027 208.567 90.9828 207.608C96.4481 205.907 99.8561 211.187 100.194 215.127C100.531 219.067 94.501 220.574 90.9552 220.309C88.2591 220.107 86.2574 222.779 85.4528 224.071C85.1978 224.48 85.1468 224.982 85.3075 225.437Z",
    fill: "url(#paint13_linear_4_50729)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5494 238.347C84.5494 238.347 83.6665 231.507 80.8211 231.172C77.9759 230.837 75.2065 233.175 78.0352 237.015C81.554 241.79 84.5494 238.347 84.5494 238.347Z",
    fill: "url(#paint14_linear_4_50729)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.861 186.386L315.005 185.338C318.809 185.314 321.898 188.219 321.869 191.792L321.17 277.986C321.14 281.579 317.97 284.447 314.146 284.339L149.802 279.699C146.151 279.596 143.235 276.81 143.188 273.38L142.088 192.872C142.04 189.32 145.079 186.409 148.861 186.386Z",
    fill: "url(#paint15_linear_4_50729)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.356 279.083L149.973 274.443C149.337 274.426 148.832 273.931 148.822 273.313L147.723 192.805C147.718 192.488 147.839 192.201 148.072 191.977C148.3 191.76 148.584 191.646 148.899 191.644L315.044 190.596C315.365 190.596 315.651 190.708 315.878 190.921C316.115 191.145 316.238 191.433 316.235 191.753L315.537 277.945C315.53 278.573 315.001 279.083 314.356 279.083ZM315.131 191.743L148.907 192.748L149.926 273.297L150.003 273.339L314.371 277.979L315.131 191.743Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M158.445 203.575C158.445 206.355 160.169 208.608 162.295 208.608H303.607C305.733 208.608 307.457 206.355 307.457 203.575C307.457 200.795 305.733 198.542 303.607 198.542H162.295C160.169 198.542 158.445 200.795 158.445 203.575Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.136 213.922H218.631C220.738 213.922 222.445 215.526 222.445 217.504V263.641C222.445 265.658 220.672 267.278 218.526 267.222L160.248 265.704C158.221 265.651 156.593 264.119 156.541 262.215L155.324 217.596C155.268 215.582 156.991 213.922 159.136 213.922Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.86 215.057H301.273C302.717 215.057 303.889 216.408 303.889 218.075C303.889 219.742 302.717 221.094 301.273 221.094H234.86C233.416 221.094 232.244 219.742 232.244 218.075C232.244 216.408 233.416 215.057 234.86 215.057Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M232.244 231.001C232.244 232.665 233.413 234.014 234.856 234.014H301.277C302.72 234.014 303.889 232.665 303.889 231.001V229.138C303.889 227.445 302.68 226.085 301.214 226.126L234.792 227.989C233.375 228.028 232.244 229.365 232.244 231.001Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M367.723 221.884C367.723 221.884 368.81 269.198 418.558 277.495L427.489 268.678C427.489 268.678 384.41 254.032 373.197 223.423L375.592 207.19L373.904 196.447L367.723 221.884Z",
    fill: "url(#paint16_linear_4_50729)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M452.762 203.87L255.394 208.701C247.393 208.897 240.556 202.973 239.61 195.026L223.941 63.3599C222.874 54.3981 229.654 46.4212 238.67 46.0286L448.38 36.8989C457.054 36.5212 464.35 43.3369 464.563 52.0173L467.89 187.982C468.1 196.547 461.327 203.66 452.762 203.87Z",
    fill: "url(#paint17_linear_4_50729)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M444.764 196.943L262.494 201.405C255.105 201.585 248.794 196.241 247.925 189.067L233.521 70.2129C232.541 62.1232 238.805 54.9184 247.132 54.5594L440.801 46.211C448.813 45.8656 455.547 52.0149 455.739 59.8511L458.743 182.593C458.932 190.325 452.673 196.75 444.764 196.943Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M225.527 73.71L465.248 62.9577L464.981 52.3403C464.768 43.6598 457.465 36.6736 448.79 37.0512L239.077 46.0956C230.06 46.4882 223.294 54.7639 224.361 63.7257L225.527 73.71Z",
    fill: "url(#paint18_linear_4_50729)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M315.598 164.5L261.366 166.933C259.523 167.015 257.779 162.267 257.381 156.078L254.21 106.806C253.773 100.017 255.116 94.1896 257.138 94.0989L312.329 91.6233C314.261 91.5365 316.064 96.7408 316.356 103.247L318.568 152.562C318.86 159.069 317.53 164.413 315.598 164.5Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M446.97 96.0371L323.975 101.554C323.399 101.58 322.91 101.133 322.884 100.556L322.589 93.9755C322.563 93.3987 323.01 92.9101 323.587 92.8842L446.581 87.3675C447.158 87.3416 447.647 87.7883 447.672 88.3652L447.967 94.9458C447.993 95.5227 447.547 96.0112 446.97 96.0371Z",
    fill: "url(#paint19_linear_4_50729)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M448.966 126.88L325.972 132.397C325.395 132.423 324.906 131.976 324.88 131.399L324.585 124.818C324.559 124.242 325.006 123.753 325.583 123.727L448.577 118.21C449.154 118.184 449.643 118.631 449.668 119.208L449.964 125.789C449.989 126.366 449.543 126.854 448.966 126.88Z",
    fill: "url(#paint20_linear_4_50729)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M391.268 82.8023L255.417 88.8958C254.84 88.9216 254.351 88.4749 254.326 87.898L254.03 81.3174C254.004 80.7405 254.451 80.252 255.028 80.2261L390.88 74.1327C391.457 74.1068 391.945 74.5535 391.971 75.1304L392.266 81.711C392.292 82.2879 391.845 82.7764 391.268 82.8023Z",
    fill: "url(#paint21_linear_4_50729)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M447.646 111.167L324.651 116.684C324.074 116.709 323.586 116.263 323.56 115.686L323.265 109.105C323.239 108.528 323.686 108.04 324.262 108.014L447.257 102.497C447.834 102.471 448.322 102.918 448.348 103.495L448.643 110.076C448.669 110.652 448.223 111.141 447.646 111.167Z",
    fill: "url(#paint22_linear_4_50729)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M449.817 142.845L326.823 148.361C326.246 148.387 325.758 147.94 325.732 147.364L325.437 140.783C325.411 140.206 325.857 139.718 326.434 139.692L449.429 134.175C450.006 134.149 450.494 134.596 450.52 135.173L450.815 141.753C450.841 142.33 450.394 142.819 449.817 142.845Z",
    fill: "url(#paint23_linear_4_50729)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M451.814 173.687L328.819 179.204C328.242 179.23 327.754 178.783 327.728 178.206L327.433 171.626C327.407 171.049 327.854 170.56 328.43 170.535L451.425 165.018C452.002 164.992 452.49 165.439 452.516 166.016L452.811 172.596C452.837 173.173 452.39 173.662 451.814 173.687Z",
    fill: "url(#paint24_linear_4_50729)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M450.493 157.974L327.499 163.491C326.922 163.517 326.434 163.07 326.408 162.493L326.112 155.913C326.087 155.336 326.533 154.847 327.11 154.821L450.104 149.305C450.681 149.279 451.17 149.725 451.196 150.302L451.491 156.883C451.517 157.46 451.07 157.948 450.493 157.974Z",
    fill: "url(#paint25_linear_4_50729)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M243.585 64.9786C246.013 64.9786 247.981 63.0105 247.981 60.5828C247.981 58.1551 246.013 56.187 243.585 56.187C241.158 56.187 239.189 58.1551 239.189 60.5828C239.189 63.0105 241.158 64.9786 243.585 64.9786Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M260.715 62.9179C262.353 61.126 262.228 58.3455 260.436 56.7076C258.644 55.0696 255.864 55.1943 254.226 56.9862C252.588 58.7781 252.712 61.5586 254.504 63.1966C256.296 64.8346 259.077 64.7098 260.715 62.9179Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M273.374 63.6424C275.802 63.6424 277.77 61.6743 277.77 59.2466C277.77 56.8189 275.802 54.8508 273.374 54.8508C270.947 54.8508 268.979 56.8189 268.979 59.2466C268.979 61.6743 270.947 63.6424 273.374 63.6424Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M415.822 383.993C415.822 383.993 439.425 435.435 451.808 456.742C451.808 456.742 454.268 470.149 451.808 474.365L449.712 475.297L459.495 475.006C459.495 475.006 460.364 456.972 459.685 455.965C459.007 454.958 457.649 455.024 457.649 455.024C457.649 455.024 453.454 421.792 441.307 414.699L429.534 374.151L415.822 383.993Z",
    fill: "url(#paint26_linear_4_50729)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M445.533 477.823C445.519 478.059 453.172 477.951 457.329 477.875C458.864 477.847 460.173 476.768 460.5 475.268L463.64 458.773C463.938 457.206 462.943 455.683 461.387 455.328L459.635 454.927C459.635 454.927 457.135 458.357 457.922 461.585C458.709 464.814 459.409 473.178 457.42 474.152C455.432 475.127 449.711 475.297 449.711 475.297C449.711 475.297 445.664 475.698 445.533 477.823Z",
    fill: "url(#paint27_linear_4_50729)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M393.449 478.122C392.675 478.563 392.995 479.745 393.885 479.736C400.843 479.666 416.432 479.446 417.818 478.87C419.606 478.126 417.166 471.699 414.598 469.524L400.417 474.152L393.449 478.122Z",
    fill: "url(#paint28_linear_4_50729)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M389.047 380.712C389.047 380.712 404.299 454.498 408.614 468.892L398.407 475.297C398.407 475.297 403.522 474.427 407.315 474.152C411.108 473.877 414.597 469.524 414.597 469.524L413.374 467.574C413.374 467.574 409.549 394.189 410.48 385.856L389.047 380.712Z",
    fill: "url(#paint29_linear_4_50729)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.185 208.604C351.185 208.604 349.082 246.987 384.027 266.601L375.614 285.79C375.614 285.79 343.975 266.653 345.145 214.46C345.179 212.962 344.638 211.508 343.66 210.373L336.936 202.572C334.374 199.6 333.416 195.568 334.369 191.761L335.254 188.223C335.55 187.039 336.899 186.469 337.955 187.082L338.658 187.491C340.897 188.791 342.67 190.762 343.727 193.125L347.029 200.506C348.262 203.263 351.106 204.937 354.115 204.677L356.156 204.501L351.185 208.604Z",
    fill: "url(#paint30_linear_4_50729)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M382.81 263.725C388.657 265.346 408.463 270.556 420.828 270.344L413.236 313.185L413.84 320.173L389.088 320.062C389.088 320.062 382.12 303.879 376.623 295.811C375.035 293.481 376.217 290.702 377.116 288.03L375.88 287.206C374.622 286.369 374.076 284.795 374.546 283.359L380.573 264.917C380.886 263.987 381.865 263.463 382.81 263.725Z",
    fill: "#A466BE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M387.106 316.405L387.593 320.638C387.593 320.638 380.598 341.587 391.09 390.514C391.09 390.514 413.815 396.952 432.492 381.547C432.492 381.547 427.223 335.367 425.784 333.216C418.616 322.502 413.842 320.173 413.842 320.173L413.626 315.548C413.626 315.548 393.65 319.16 387.106 316.405Z",
    fill: "#F0E3FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M396.796 267.178C396.709 267.063 401.964 251.314 401.964 251.314L409.49 251.997L412.43 269.863C412.43 269.863 400.635 272.244 396.796 267.178Z",
    fill: "url(#paint31_linear_4_50729)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M407.689 226.477C407.187 226.79 391.606 233.229 394.953 249.405C395.151 250.361 395.789 251.171 396.68 251.569C398.967 252.589 403.889 254.335 409.777 253.737C417.939 252.907 423.288 238.664 423.06 234.519C422.833 230.374 412.663 223.38 407.689 226.477Z",
    fill: "url(#paint32_linear_4_50729)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M412.429 220.189C412.019 220.242 403.425 223.236 407.687 229.464C411.949 235.691 413.548 239.357 411.532 242.092C409.696 244.584 405.627 243.164 405.982 248.347C406.053 249.385 405.604 250.392 404.743 250.975C400.909 253.57 391.556 261.558 400.823 272.95C401.576 273.876 401.731 275.154 401.15 276.197C398.436 281.065 392.734 295.327 413.376 303.239C433.773 311.056 441.137 297.723 443.194 292.394C443.64 291.241 444.774 290.536 446.008 290.594C448.25 290.7 451.426 290.327 451.28 287.332C451.191 285.513 450.056 283.882 448.714 282.575C447.387 281.282 447.649 279.016 449.261 278.101C450.478 277.409 451.556 276.329 452.011 274.644C453.247 270.063 450.779 256.368 437.652 254.047C436.557 253.853 435.41 252.826 435.25 251.726C435.248 251.71 435.245 251.693 435.243 251.677C435.067 250.613 435.427 249.524 436.297 248.886C438.393 247.348 441.081 244.253 438.898 239.288C436.961 234.885 433.247 233.4 430.488 232.926C428.868 232.648 427.803 231.116 428.145 229.509C429.075 225.128 428.264 218.112 412.429 220.189Z",
    fill: "url(#paint33_linear_4_50729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_50729",
    x1: 270.821,
    y1: 78.4454,
    x2: 199.721,
    y2: 529.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_50729",
    x1: 24.0584,
    y1: 472.56,
    x2: 42.7617,
    y2: 472.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_50729",
    x1: 25.9551,
    y1: 463.868,
    x2: 33.5405,
    y2: 463.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_50729",
    x1: 63.832,
    y1: 472.26,
    x2: 93.178,
    y2: 472.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_50729",
    x1: 64.2774,
    y1: 460.5,
    x2: 71.8209,
    y2: 460.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_50729",
    x1: 43.0132,
    y1: 352.593,
    x2: 159.481,
    y2: 256.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_50729",
    x1: 131.163,
    y1: 176.735,
    x2: 63.5362,
    y2: 324.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_50729",
    x1: 114.75,
    y1: 239.615,
    x2: 142.786,
    y2: 239.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_50729",
    x1: 88.9566,
    y1: 232.081,
    x2: 73.61,
    y2: 377.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_50729",
    x1: 178.231,
    y1: 245.727,
    x2: 117.654,
    y2: 321.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_50729",
    x1: 189.715,
    y1: 254.959,
    x2: 129.138,
    y2: 330.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_50729",
    x1: 110.082,
    y1: 200.182,
    x2: 51.4127,
    y2: 307.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_50729",
    x1: 91.5931,
    y1: 220.042,
    x2: 90.1911,
    y2: 263.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_50729",
    x1: 80.1855,
    y1: 238.222,
    x2: 105.49,
    y2: 220.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_50729",
    x1: 76.2317,
    y1: 264.135,
    x2: 80.9176,
    y2: 234.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_50729",
    x1: 303.609,
    y1: 127.394,
    x2: 4.13706,
    y2: 576.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A49D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67FF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_50729",
    x1: 376.271,
    y1: 194.435,
    x2: 404.243,
    y2: 266.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_50729",
    x1: 443.674,
    y1: 25.3675,
    x2: 175.165,
    y2: 298.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1DBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_50729",
    x1: 372.87,
    y1: -130.324,
    x2: 355.422,
    y2: -11.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A49D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_50729",
    x1: 417.006,
    y1: -135.457,
    x2: 321.884,
    y2: 133.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_50729",
    x1: 419.003,
    y1: -104.614,
    x2: 323.881,
    y2: 164.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_50729",
    x1: 356.351,
    y1: -65.8867,
    x2: 290.409,
    y2: 226.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_50729",
    x1: 419.682,
    y1: -134.817,
    x2: 324.56,
    y2: 134.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_50729",
    x1: 419.854,
    y1: -88.6497,
    x2: 324.732,
    y2: 180.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4_50729",
    x1: 421.85,
    y1: -57.8068,
    x2: 326.728,
    y2: 211.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_50729",
    x1: 422.529,
    y1: -88.0093,
    x2: 327.407,
    y2: 181.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4_50729",
    x1: 452.658,
    y1: 424.724,
    x2: 496.779,
    y2: 424.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4_50729",
    x1: 476.468,
    y1: 326.054,
    x2: 454.617,
    y2: 468.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4_50729",
    x1: 430.234,
    y1: 318.942,
    x2: 408.384,
    y2: 460.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4_50729",
    x1: 432.668,
    y1: 428.004,
    x2: 458.218,
    y2: 428.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4_50729",
    x1: 334.008,
    y1: 236.311,
    x2: 384.027,
    y2: 236.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4_50729",
    x1: 396.795,
    y1: 260.868,
    x2: 412.43,
    y2: 260.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4_50729",
    x1: 421.645,
    y1: 240.663,
    x2: 535.45,
    y2: 248.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4_50729",
    x1: 440.349,
    y1: 233.803,
    x2: 400.29,
    y2: 313.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutResDesign);
export default __webpack_public_path__ + "static/media/AboutRes-Design.21073a5d6627a929bf691a240419a8d9.svg";
export { ForwardRef as ReactComponent };